const UserAgreement = () => {
  return (
    <div style={{ maxHeight: "80vh", overflow: "auto" }}>
      <h3 style={{ textAlign: "center" }}>Valcour CAD/RMS System Policies</h3>
      <h3 style={{ textAlign: "center" }}>User Agreement</h3>
      <h5 style={{ textAlign: "center" }}>I. Purpose</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          Valcour is a proprietary software solution, developed by CrossWind
          Technologies, (hereinafter “CrossWind”) designed exclusively for
          legitimate public safety use. Valcour is designed to be used by
          multiple departments or agencies as a secure automated Computer Aided
          Dispatch, Records Management, and Mobile Computing system that gathers
          data for a variety of public safety purposes, including but not
          limited to, records of services rendered, incident/event information,
          information about persons involved in investigations, crimes reported,
          arrests, stolen and recovered property and crime data.
        </li>
      </ol>
      <h5 style={{ textAlign: "center" }}>II. Definitions</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          2.1 Valcour Agency - A public safety agency using Valcour in a
          read-write capacity that has a federal ORI number and whose mission,
          purpose, or focus is the investigation or prosecution of criminal
          activity. Hereinafter “Agency.”
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          2.2 Non-Contributing Agency -A public safety agency that uses the
          system in a read-only capacity for law enforcement investigative and
          prosecutive purposes. Hereinafter “Agency.”
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          2.3 Designated Contacts - The Valcour Governance Board, with input
          from CrossWind, will designate contacts (hereinafter “Designated
          Contacts”) who will be responsible for communicating with CrossWind
          Technical Support by telephone or email.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          2.4 Personal Identifying Information - Personally identifiable
          information is one or more pieces of information, when considered
          together, or combined with other information, identifies a unique
          individual.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          2.5 Program Manager - A person designated as a system specialist
          within the Agency who acts as the main point of contact between Agency
          and CrossWind.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          2.6 User - A user is an individual authorized by an Agency head to
          have access to the information contained in the database(s) of the
          Valcour network. The user must be under the employment of the Agency
          head or under contract or agreement where the Agency head has the
          ability to monitor the user&apos;s use of the network. All users must have
          a fingerprint supported background check before they are given access
          to the Valcour data.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          2.7 General Data- General data includes dates and times of incidents;
          broad biographical information such as race, gender, and age that does
          not personally identify an individual; general vehicle information
          excluding biographical information; general incident type, crime,
          violation, or ordinance reporting; and location information such as
          street and intersection but not street number or other exact
          geo-referenced location; and any other data approved by the Board.
        </li>

        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          2.8 Specific Data- All other data not defined as general data is
          specific data, which includes but is not limited to: individual
          incident reports, narratives, documents, images, video, audio, the
          identities of any person involved in an incident including staff,
          personal identifying information such as names, dates of birth, or
          license numbers, specific street addresses (by street number), and
          information related to any event that has been partitioned or blocked
          by a user or agency because disclosure of any fragment of the incident
          would compromise an ongoing investigation.
        </li>
      </ol>

      <h5 style={{ textAlign: "center" }}>III. Agency Policies</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          Each Agency shall make any requisite changes to their rules and
          regulations to accommodate and enforce the Valcour System Policies.
        </li>
      </ol>

      <h5 style={{ textAlign: "center" }}>IV. Use Limitations</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          4.1 All data residing on the system is the property of the respective
          agencies participating. Any release of specific data MUST be done by,
          or with the express consent of, the primary investigating Agency (the
          ORI who originates the data).
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          4.2 Because the system allows for personal identifying information
          (person records without incident detail) within the system to be
          shared among ORIs, those portions of the data is accessible to all
          users but may only be released or disseminated ONLY for law
          enforcement purposes. Examples of such personal identifying
          information may include but is not limited to dates of birth, place of
          birth, address and phone number – but not incident specific detail.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          4.3 Any specific data taken from the system released for any reason
          other than a legitimate public safety purpose may be subject to
          criminal or civil penalties. General data as defined in the above
          definition section may be released at the discretion and caution of
          the user with respect to the public safety mission of the Valcour
          system.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          4.4 Users may access Valcour records for legitimate law enforcement
          purposes only. Accessing records for personal interest, curiosity,
          convenience, or any non-official reason is strictly prohibited. The
          Valcour Governance Board shall be the sole authority for determining
          what legitimate law enforcement purpose is by policy or on a
          case-by-case basis.
        </li>
      </ol>

      <h5 style={{ textAlign: "center" }}>V. Security</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.1 Only individuals who have signed, either electronically and/or in
          original copy, a user agreement and who comply with the user agreement
          shall be permitted to access the system. User will be assigned a
          unique user login and shall create a password that complies with
          contemporary security standards. The Valcour CAD/RMS System Policies
          User Agreement is presented as a click-thru screen upon a User’s login
          to Valcour. Entry will not be allowed unless the User accepts the
          terms of the agreement.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.2 Pursuant to CJIS requirements: 5.5.4 System Use Notification, the
          user acknowledges that:
        </li>
        <ol>
          <li style={{ marginBottom: "0.5em" }}>
            The user is accessing a restricted information system;
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            System usage may be monitored, recorded, and subject to audit;
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            Unauthorized use of the system is prohibited and may be subject to
            criminal and/or civil penalties;
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            Use of the system indicates consent to monitoring and recording.
          </li>
        </ol>
        <br />
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.3 Users shall not allow any device or software (including browsers
          or add-ons) to store their passwords for Valcour nor shall they share
          their passwords with any other person. Likewise, users shall not leave
          any device logged on to Valcour unattended or allow any non-public
          safety personnel to access a device that has an active Valcour login
          enabled.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.4 Users shall not access Valcour from any public computer. Valcour
          shall only be authorized and accessed on Agency owned devices.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.5 Each Agency shall make a reasonable effort to ensure that all
          users comply with the user policy and shall immediately inform the
          Program Manager(s) of any breach or possible breach of security and/or
          any violations or potential violations of this policy.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.6 Although reasonable efforts are taken to ensure system security,
          absolute security cannot be guaranteed. Therefore, the following
          material should be stored on the Valcour network at the user&apos;s
          discretion:
        </li>
        <ol type="A">
          <li style={{ marginBottom: "0.5em" }}>
            Any investigative work which if compromised would jeopardize the
            outcome of a criminal investigation;
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            Information which, if compromised, would place an individual in
            jeopardy – including but not limited to the names of confidential
            informants.
          </li>
        </ol>
        <br />
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.7 Users shall report any suspicious system activity to the Program
          Manager.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.8 Users shall not provide, discuss, or describe system related
          information of any kind with non-public safety personnel.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.9 Users shall not place hardware or software on any device that is
          connected to the Valcour system that may compromise the security of
          the network. Examples may include but are not limited to internet
          usage surveillance software that logs key strokes.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          5.10 All logging of system activity is based on login and password.
          Login and password security is CRITICAL:
        </li>
        <ol type="A">
          <li style={{ marginBottom: "0.5em" }}>
            Users may be held responsible for anything that takes place
            utilizing their login. DO NOT REVEAL YOUR PASSWORD TO ANYONE FOR ANY
            REASON. Do not allow anyone to use your login and password. Valcour
            Program Managers will NEVER need to ask you for your password.
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            Never put your password in a document stored on the computer system.
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            If you feel that the secrecy of your password has been compromised,
            change it immediately and notify your Agency Program Manager.
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            If you forget your password, send a request for password reset to
            your Agency Program Manager.
          </li>
        </ol>
      </ol>
      <h5 style={{ textAlign: "center" }}>VI. System Usage</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          6.1. Only activities that relate to public safety, law enforcement or
          criminal justice shall be allowed on the system.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          6.2 Recognizing the need for data integrity, it is strictly prohibited
          for any user to intentionally modify system data in such a way that it
          would make the data erroneous, inaccurate, or inappropriate. Any user
          who modifies data inappropriately may be subject to sanctions
          contained below and/or to criminal prosecution.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          6.3 By logging into the Valcour system, users are presented with a
          current copy of this user agreement, as amended. The user must agree
          to the terms as presented prior to logging into the Valcour system
          each session.
        </li>
      </ol>
      <h5 style={{ textAlign: "center" }}>VII. Policy Review</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          This policy shall be reviewed by Agency and/or Program Managers
          annually, or as required. Suggested policy changes must be approved by
          the Valcour Governance Board
        </li>
      </ol>
      <h5 style={{ textAlign: "center" }}>VIII. Acknowledgements & Support</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          8.1 Program Managers and administrators reserve the right to monitor
          the system.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          8.2 Program Managers may request changes to this document where it can
          be shown that such changes are needed in order to enhance security or
          operational needs. Changes can be made subject to the Valcour
          Governance Board’s approval.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          8.3 Users shall report any problems, errors, or requests to the Agency
          Program Manager.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          8.4 Users are encouraged to utilize all resources provided by their
          Agency, including expert users, online Help and the Agency Info page
          to troubleshoot prior to sending help desk requests.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          8.5 Users shall notify a supervisor of any Valcour related issue that
          requires immediate attention. Supervisors shall follow the Valcour
          support flow chart to enlist assistance.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          8.6 Users shall not attempt to change any system setting or perform
          any system modifications.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          8.7 Occasionally the system will need to be brought down for
          maintenance. Advance notice will be given where practical.
        </li>
      </ol>
      <h5 style={{ textAlign: "center" }}>IX. Sanctions</h5>
      <ol>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          9.1 Agencies and users of the system shall adhere to this policy and
          any other mandatory rule, policy or procedure of the systems that
          co-exist with Valcour including but not limited to Valcour network,
          the Vermont Justice Information Sharing System (VJISS) and NCIC - the
          FBI Criminal Justice Information Systems related policy. Failure to do
          so may result in the user or Agency being sanctioned.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          9.2 Sanctions could result in a loss of privileges (disconnection) of
          the Agency or user and may be subject to civil and/or criminal
          liability and/or prosecution in state and/or federal court.
        </li>
        <li style={{ listStyleType: "none", marginBottom: "0.5em" }}>
          9.3 Sanctions may include the imposition emergency sanctions,
          including disconnection, if a security threat sufficient to warrant
          such action exists. Any disconnection will be subject to the review
          and concurrence of the Valcour Governance Board.
        </li>
      </ol>
      <br />
      <p>
        <strong>
          I hereby acknowledge receipt and understanding of the Valcour System
          Policies, as amended. I recognize that criminal history record
          information and related data, by its very nature, is sensitive and has
          potential for great harm if misused. I acknowledge that access to
          criminal history record information and related data is therefore
          limited to the purpose(s) for which my agency authorizes me to engage.
          I understand that misuse of the system by, among other things:
          accessing it without authorization; accessing it by exceeding
          authorization; accessing it for an improper purpose; using,
          disseminating or re-disseminating information for a purpose other than
          that envisioned by my agency, may subject me to administrative and
          criminal penalties. I understand that accessing the system for an
          appropriate purpose and then using, disseminating or re-disseminating
          the information received for another purpose other than that
          envisioned by my agency also constitutes misuse. Such exposure for
          misuse includes, but is not limited to, suspension or loss of
          employment and prosecution for state and federal crimes.
        </strong>
      </p>
    </div>
  );
};

export default UserAgreement;
